import React from 'react';
import { Select } from 'antd';
import State from '../State';

const { compressionModes } = State;
const { Option } = Select;

export default class Recompress extends React.PureComponent {
	constructor(props) {
		super(props);
		this.select = React.createRef();
	}
	onChange = value => {
		const { onCompressionModeChanged } = this.props;
		onCompressionModeChanged(compressionModes[value]);
	}
	render = () => {
		const { compressionMode } = this.props;
		return (
			<Select
				defaultValue={compressionMode}
				style={{ width: 100 }}
				onChange={this.onChange}
				ref={this.select}
			>
				<Option
					value={compressionModes.Normal.name}
				>{compressionModes.Normal.name}
				</Option>
				<Option
					value={compressionModes.Good.name}
				>{compressionModes.Good.name}
				</Option>
				<Option
					value={compressionModes.High.name}
				>{compressionModes.High.name}
				</Option>
				<Option
					value={compressionModes.Extreme.name}
				>{compressionModes.Extreme.name}
				</Option>
			</Select>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Recompress.js